<template>
  <v-container grid-list-xl fluid>
    <confirm ref="confirm"></confirm>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card>
      <v-card-title>
        <span class="title">Ingreso Órdenes de Compra - Mercado Público</span>
        <v-spacer></v-spacer>
          <v-btn
                            fab
                            dark
                            small
                           color="primary"
                           style="margin:0px"
                           @click="refresh()"
                          > 
                            <v-icon dark  >refresh</v-icon>
                          </v-btn>
      </v-card-title>
    </v-card>
    <v-layout row wrap>
      <!--
      <v-flex sm12 xs12 md12 lg6 v-if="!loading">
        <v-card>
          <v-toolbar card dense color="transparent">
            <v-toolbar-title>
              <h5>OC Pendientes Aceptación</h5>
            </v-toolbar-title>
            <v-spacer />
             <v-text-field
                v-model="searchPendienteAceptacion"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
                @change="findPendienteAceptacion()"
                @keypress="findPendienteAceptacion()"
                @keyup="findPendienteAceptacion()"
                class="mb-2"
              ></v-text-field>
             <div class="text-xs-center " :style="{visibility: loadingPendiente ? 'visible' : 'hidden'}" >  
                <v-progress-circular  
                  indeterminate :size="20"
                  color="primary"  
                ></v-progress-circular>
             </div>
          </v-toolbar>
         
          <v-divider></v-divider>
            
          <v-card-text class="pa-0">
           
            <v-list two-line class="pa-0 comentariosHome comentarioStatusLineasHome">
               
              <template v-for="(item, index) in detallePendiente" >                
                <v-divider :key="index"></v-divider>
                <v-list-tile avatar :key="item.id" @click="handleClick(item)">
                  
                  <v-list-tile-content>
                    <v-list-tile-title class="comentarioStatusHome caption">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <td style="width:25%;">
                          <v-btn  :color="calculaStatus(item.estadoGestion)" small dark slot="activator" @click="irOC(item.codigo)"  v-on="on">
                            <v-icon>zoom_in</v-icon>
                            {{ item.codigo }}
                          </v-btn>
                          
                          <td style="width:45%;">
                          <span v-on="on">
                            Últ. Actualización : {{ getHumanDate(item.fechaEstado) }}
                            <v-icon class="ml-2">account_circle</v-icon>
                            {{ item.usuarioGestion }}
                          </span>
                          </td>
                        </template>
                        <span>
                          {{ item.codigo }} - {{ item.estadoGestion }} -
                          {{ getHumanDate(item.fechaEstado) }}
                        </span>
                        <br />
                        <span class="font-italic">
                          <v-icon>account_circle</v-icon>
                          {{ item.usuarioGestion }}
                        </span>
                      </v-tooltip>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
            <v-divider></v-divider>
             
              <v-btn block flat class="ma-0" @click='verTodosPendiente()'>Ver todas</v-btn> 
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
      </v-flex>-->
     
      <v-flex sm12 xs12 md12 lg12 v-if="!loading">
        <v-card>
      <v-card-title>
        <span class="title">Últimas 10 OC Canceladas</span>
        
      </v-card-title>
    </v-card>
        <v-card>
          <v-toolbar card dense color="transparent">
          
             <date-range-picker @update:dateRange="handleDateRangeChangeCanceladas"  />
             <v-spacer />
              <v-text-field
                v-model="searchCancelada"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
                 @change="findCancelada()"
                @keypress="findCancelada()"
                @keyup="findCancelada()"
                 class="mb-2"
              ></v-text-field>
             <div class="text-xs-center" :style="{visibility: loadingCancelada ? 'visible' : 'hidden'}" >  
                <v-progress-circular  
                  indeterminate :size="20"
                  color="primary"  
                ></v-progress-circular>
             </div>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-list two-line class="pa-0 comentariosHome comentarioStatusLineasHome">
              <template v-for="(item, index) in detalleCanceladas">
                <v-divider ></v-divider>
                <v-list-tile avatar  @click="handleClick(item)">
                  <!-- public long Id { get; set; }
                          public string Codigo { get; set; }
                          public DateTime? FechaEstado { get; set; }
                          public string UsuarioGestion { get; set; }
                          public string EstadoGestion { get; set; }
                          public string Nombre { get; set; }
                          public string NombreOrganismo { get; set; }
                          public DateTime? FechaEnvio { get; set; }
                          public string Tipo { get; set; }
                          public string TipoMoneda { get; set; }
                          public float? Total { get; set; }
                          public string TotalFormat    >-->
                   <v-list-tile-content>
                    <v-list-tile-title class="comentarioStatusHome caption">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <td style="width:25%;">
                          <v-btn  :color="calculaStatus(item.estadoGestion)" small dark slot="activator" @click="irOC(item.codigo)"  v-on="on">
                            <v-icon>zoom_in</v-icon>
                            {{ item.codigo }}
                          </v-btn>
                          </td>
                         <!-- <td style="width:20%;">
                          <v-btn
                            :color="calculaStatus(item.estadoGestion)"
                            class="white--text"
                            small
                            v-on="on"
                          ><v-icon class="mr-1">info</v-icon>{{ item.estadoGestion }}</v-btn>
                          </td>-->
                          <td style="width:45%;">
                          <span v-on="on">
                            Últ. Actualización : {{ getHumanDate(item.fechaEstado) }}
                            <v-icon class="ml-2">account_circle</v-icon>
                            {{ item.usuarioGestion }}
                          </span>
                          </td>
                        </template>
                        <span>
                          {{ item.codigo }} - {{ item.estadoGestion }} -
                          {{ getHumanDate(item.fechaEstado) }}
                        </span>
                        <br />
                        <span class="font-italic">
                          <v-icon>account_circle</v-icon>
                          {{ item.usuarioGestion }}
                        </span>
                      </v-tooltip>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
            <v-divider></v-divider>
             <v-btn block flat class="ma-0" @click='verTodosCanceladas()'>Ver todas</v-btn> 
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
      </v-flex>

     
      <v-flex xs12>
        <v-card>
      <v-card-title>
        <span class="title">OC's Pendientes Validación</span>
        
      </v-card-title>
    </v-card>
        <v-card>
          <v-toolbar card dense color="transparent">
             
            
            <date-range-picker @update:dateRange="handleDateRangeChange"   />
              <v-btn color="green" small dark flat  @click="getOCDashboardExcelFechas('PENDIENTE VALIDACION')" >                 
              <v-icon>attach_file</v-icon>Descargar OC's Pendientes Validación
            </v-btn>
             
            

               <v-text-field
                   v-model="search"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
                 class="mb-2"
                 @change="getOCPendienteValidacion()"
            required
              ></v-text-field>
             <div class="text-xs-center" :style="{visibility: loadingValidacion ? 'visible' : 'hidden'}" >  
                <v-progress-circular  
                  indeterminate :size="20"
                  color="primary"  
                ></v-progress-circular>
             </div>
          </v-toolbar>
          <v-divider/>
         
          <v-card-text class="mt-0">            

            <v-data-table
              :headers="headers"
              :search="search"
              :items="detalleItems"
               :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              rows-per-page-text="Registros por página"
               no-results-text=""
              no-data-text=""
              class="elevation-1"              
            >
              <template v-slot:items="props">
                <td> <v-btn :color="calculaStatus(props.item.estadoGestion)" small dark  @click="irOC(props.item.codigo)" slot="activator">
                <v-icon>zoom_in</v-icon>
                {{ props.item.codigo }}
              </v-btn></td>
                
                <td class="truncate">{{ props.item.nombre }}</td>

                <td>
                    {{ props.item.nombreOrganismo }}
                     

                </td>
                <td>
                    {{ props.item.regionUnidad }}
                     

                </td>
              
                <td>{{ getHumanDate(props.item.fechaEnvio) }}</td>
                <td>{{ props.item.tipo }}</td>
                <td>{{ props.item.tipoMoneda }}</td>
                <td>{{ props.item.totalFormat }}</td>
              </template>
              <template slot="pageText" slot-scope="props">
                Registros {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Su busqueda "{{ search }}" no obtuvo resultados.</v-alert>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
.comentariosHome {
  height: 260px;
  overflow-y: auto;
}
.comentarioStatusHome {
  height: 40px;
}
.comentarioStatusLineasHome.v-list--two-line .v-list__tile {
  height: 40px;
  margin-bottom: 3px;
}
.truncate {
  max-width:200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
//import LicitacionesService from "@/services/LicitacionesService";
import DateRangePicker from "@/components/DateRangePicker";
import OrdenCompraService from "@/services/OrdenCompraService";
import Loader from "@/components/Loader";
import moment from "moment";
//import FiltrosService from "@/services/FiltrosService";
import VWidget from "@/components/VWidget";
import AppEvents from "@/eventBus";
//import LicitacionesItems from "@/components/LicitacionesItems";
import BarChart from '@/components/bar';
export default {
  components: {
    VWidget,
    Loader,
    BarChart,
    DateRangePicker
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    fechaIni: null,
    fechaFin: null,
    fechaIniCanceladas: null,
    fechaFinCanceladas: null,
    search: null,
    searchPendienteAceptacion: null,
    searchCancelada: null,
    loading: false,
    loadingPendiente: false,
    loadingValidacion: false,
    loadingCancelada: false,


    ofertadasAdjudicadas: [],
    soloOfertada: [],
loadingChart: false,
labels:[],
    /*
public long Id { get; set; }
        public string Codigo { get; set; }
        public DateTime? FechaEstado { get; set; }
        public string UsuarioGestion { get; set; }
        public string EstadoGestion { get; set; }
        public string Nombre { get; set; }
        public string NombreOrganismo { get; set; }
        public DateTime? FechaEnvio { get; set; }
        public string Tipo { get; set; }
        public string TipoMoneda { get; set; }
        public float? Total { get; set; }
        public string TotalFormat    
    
    */
    detallePendiente: [],
    detallePendienteServer: [],
    detalleCanceladas: [],
    detalleCanceladasServer: [],
    detalleItems: [],   
    rowsPerPageItems: [10, 20, 50, 100],
    pagination: {
      page: 1,
      rowsPerPage: 10,
      sortBy: "fechaEnvio",
      descending: true
    },  
    totalItems: 0,    
    headers: [
      {
        text: "Código",
        align: "left",
        sortable: true,
        value: "codigo"
      },
      {
        text: "Nombre",
        align: "left",
        sortable: true,
        value: "nombre"
      },
      {
        text: "Nombre Organismo",
        align: "left",
        sortable: true,
        value: "nombreOrganismo"
      },
       {
        text: "Región",
        align: "left",
        sortable: true,
        value: "regionUnidad"
      },
      {
        text: "Fecha Envio",
        align: "left",
        sortable: true,
        value: "fechaEnvio"
      },
      {
        text: "Tipo OC",
        align: "left",
        sortable: true,
        value: "tipo"
      },
      {
        text: "Moneda",
        align: "left",
        sortable: true,
        value: "tipoMoneda"
      },
      {
        text: "Total",
        align: "left",
        sortable: true,
        value: "total"
      }, 
    ]
  }),
  methods: {
    handleDateRangeChange({ start, end }) {
    console.log('Fecha inicial:', start);
    console.log('Fecha final:', end);    
    this.fechaIni = start;
    this.fechaFin = end;
    if(end !== null){
      
      const response = this.getOCPendienteValidacion();
    } 
  },
  handleDateRangeChangeCanceladas({ start, end }) {
    console.log('Fecha inicial Canceladas:', start);
    console.log('Fecha final Canceladas:', end);    
    this.fechaIniCanceladas = start;
    this.fechaFinCanceladas = end;
     if(end !== null){
      
      const response = this.getOCCanceladas();
    } 
  },
     getHumanDate (date)
    {
      if (!date) return '';
      if (date === '0001-01-01') return '';
      return  moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    findPendienteAceptacion()
    {
       var busqueda = this.searchPendienteAceptacion == null ? "" : this.searchPendienteAceptacion;
      this.detallePendiente = this.detallePendienteServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    findCancelada()
    {
      var busqueda = this.searchCancelada == null ? "" : this.searchCancelada;
      this.detalleCanceladas = this.detalleCanceladasServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    async refresh()
    {
      const response =  await this.getAllData();
    },
    irOC(codigo)
    {
       this.$router.push({
        name: "OrdenCompraDetalle",
        //params: { codigo: codigo },
        query: { codigo: codigo  }
      });
    },
     verTodosPendiente()
    {
       this.$router.push({
        name: "OrdenCompraPendienteAceptada"         
      });
    },
      verTodosCanceladas()
    {
       this.$router.push({
        name: "OrdenCompraCanceladas"         
      });
    },
    handleClick(item) {
      debugger;
    },
    calculaStatus(estado) {
      if (estado === "PENDIENTE ACEPTACION") {
        return "deep-purple darken-1";
      } else if (estado === "PENDIENTE VALIDACION") {
        return "blue darken-1";
      } 
      else if (estado === "CANCELADA") {
        return "red";
      } 
      else {
        return "grey";
      }
    },
    async getOCDashboardExcelFechas(estado) {
      this.loadingPendiente = true;
      let fechaInicial = this.fechaIni === null ? "NONE" : this.fechaIni;
      let fechaFinal = this.fechaFin === null ? "NONE" : this.fechaFin;
      const response = await OrdenCompraService.getOCDashboardExcelFechas(estado, fechaInicial, fechaFinal);
      this.loadingPendiente = false;
    },
     async getOCDashboardExcel(estado) {
      this.loadingPendiente = true;
      const response = await OrdenCompraService.getOCDashboardExcel(estado);
      this.loadingPendiente = false;
    },
     async getOCDashboardExcelHistorico() {
      this.loadingPendiente = true;
      const response = await OrdenCompraService.buscarItemsOCFullTextExcel();
      this.loadingPendiente = false;
    },
    async getOCPendienteAceptacion()
    {
       
      this.loadingPendiente  = true;
      let fechaInicial = this.fechaIni === null ? "NONE" : this.fechaIni;
      let fechaFinal = this.fechaFin === null ? "NONE" : this.fechaFin;
       const response = await OrdenCompraService.getOCDashboardFechas("PENDIENTE ACEPTACION", fechaInicial, fechaFinal).then(r => {
        
         debugger;
        this.detallePendienteServer = r.data;
         var busqueda = this.searchPendienteAceptacion == null ? "" : this.searchPendienteAceptacion;
         if(busqueda.length > 0)
         {
            this.detallePendiente = this.detallePendienteServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
         }
         else
         {
             this.detallePendiente = r.data;
         }
       
       
        
         this.loadingPendiente  = false;
      });
     

    },
    async getOCCanceladas()
    {
       
      this.loadingCancelada  = true;
      let fechaInicial = this.fechaIniCanceladas === null ? "NONE" : this.fechaIniCanceladas;
      let fechaFinal = this.fechaFinCanceladas === null ? "NONE" : this.fechaFinCanceladas;
       const response = await OrdenCompraService.getOCDashboardFechas("CANCELADA", fechaInicial, fechaFinal).then(r => {
   
         debugger;
        this.detalleCanceladasServer = r.data;
        var busqueda = this.searchCancelada == null ? "" : this.searchCancelada;
         if(busqueda.length > 0)
         {
            this.detalleCanceladas = this.detalleCanceladasServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
         }
         else
         {
             this.detalleCanceladas = r.data;
         }
       
        
         this.loadingCancelada  = false;
      });
     

    },
    async getOCPendienteValidacion()
    {
      let fechaInicial = this.fechaIni === null ? "NONE" : this.fechaIni;
      let fechaFinal = this.fechaFin === null ? "NONE" : this.fechaFin;
        let paging = this.pagination;
      let sort = paging.sortBy === null ? "fechaEnvio" : paging.sortBy;
      let direction =
        paging.descending === null
          ? " desc"
          : paging.descending === true
          ? " desc"
          : " asc";
      sort = sort + direction;
      let paginacion =
        "sort=" +
        sort +
        "&page=" +
        paging.page +
        "&pageSize=" +
        paging.rowsPerPage;

        debugger;
        this.loadingValidacion = true;
        var busqueda = (this.search == null ? '' : this.search);
      const response = await OrdenCompraService.getOCDashboardPagingFechas(
        
        paginacion ,
        busqueda,
        "PENDIENTE VALIDACION",
        fechaInicial, fechaFinal
      )
        .then(r => {
          debugger;
          this.detalleItems = r.data.data;
          this.totalItems = r.data.totalCount;
          this.loadingValidacion = false;


          //remover prueba graficos
        this.loadingChart = true;
     
          this.labels = ['01-2020','02-2020','03-2020','04-2020'];
          this.ofertadasAdjudicadas = [1,2,4,3]; 
          this.soloOfertada =  [1,1,2,3]; 

            
          
     


        })
        .catch(r => {
          console.log(r.response);
        });
       
     

    },
    async getAllData()
    {
      const response = await this.getOCPendienteAceptacion();
              const response1 = await this.getOCPendienteValidacion();
              const response3 = await this.getOCCanceladas();
    }
  },
  created()
  {

     AppEvents.$on('APP_REFRESH_DASHBOARD', (accion) => {
       console.log("ACTUALIZACION DASHBOARD " + accion.accion +" " + accion.codigo )
       const response = this.getAllData();
    });
  }
  ,
   mounted() {
     /*this.$refs.navidad
              .open("Saludo de navidad", "saludo de navidad", {
                color: "orange",
                width: 800
              })
              .then(confirm => {
                if (confirm) {
                   
                }
              });*/
              
              const response = this.getAllData();
  },
   watch: {
    pagination: {
      handler() {
        this.getOCPendienteValidacion();
      },
      deep: true
    },
  }
};
</script>
